var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import cookie from '../../cookie/cookie';
import { checkNum } from '../../utils/common-utils';
import { transSubType } from '../../constant/common-type';
export default Vue.extend({
    name: 'planList',
    data: function () {
        return {
            usernameZh: '',
            listForm: {
                list: [],
                otherList: [],
            },
            modeOptions: [
                {
                    val: 'DAY_AVERAGE',
                    label: '日扣平均模式',
                    disabled: this.isDisabled,
                },
                {
                    val: 'DAY_GREED',
                    label: '日扣优先模式',
                    disabled: this.isDisabled,
                },
                {
                    val: 'ACTIVE',
                    label: '主动还款',
                },
            ],
        };
    },
    props: {
        completeList: {
            type: [Object, Array],
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        newPlanAmount: {
            type: String,
            default: '0',
        },
        contractCode: {
            type: String,
            required: true,
        },
    },
    computed: __assign({}, mapState(['repayment']), { isDisabledImport: function () {
            return (this.repayment.isHasEdit ||
                !(this.listForm.otherList.length > 0 || this.listForm.list.length > 0));
        } }),
    created: function () {
        this.initData();
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        initData: function () {
            var _a = this, completeList = _a.completeList, listForm = _a.listForm;
            var list = listForm.list;
            if (completeList instanceof Array) {
                if (list.length > 0) {
                    this.listForm.list = this.listForm.list.concat(JSON.parse(JSON.stringify(completeList)));
                }
                else {
                    this.listForm.list = JSON.parse(JSON.stringify(completeList));
                }
                return;
            }
            var amountType = completeList.amountType;
            if (amountType === 'MONTHLY_RENT') {
                this.listForm.list.push(JSON.parse(JSON.stringify(completeList)));
            }
            else {
                this.listForm.otherList.push(JSON.parse(JSON.stringify(completeList)));
            }
        },
        deleteEvery: function (index, arrName) {
            var _this = this;
            this.$confirm('您确认要删除该还款计划吗?', '', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                showClose: true,
                type: 'warning',
            })
                .then(function () {
                _this.listForm[arrName].splice(index, 1);
                _this.$message({
                    type: 'success',
                    message: '删除成功!',
                });
                _this.isAddBatch();
            })
                .catch(function () { });
        },
        editEvery: function (index, arrName) {
            this.listForm[arrName][index]['isEdit'] = true;
            this.isAddBatch();
        },
        saveEvery: function (index, arrName) {
            var _this = this;
            this.$refs['listForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var eDate = _this.listForm[arrName][index].eDate;
                _this.listForm[arrName][index]['isEdit'] = false;
                _this.listForm[arrName][index].startTime = moment(eDate[0]).format('YYYY-MM-DD');
                _this.listForm[arrName][index].endTime = moment(eDate[1]).format('YYYY-MM-DD');
                _this.isAddBatch();
            });
        },
        isAddBatch: function () {
            var count = 0;
            var isHasEdit = false;
            var alreadyCreateNewPlanAmount = 0;
            var newPlanAmount = this.newPlanAmount;
            this.listForm.list.forEach(function (item) {
                if (!item.isEdit) {
                    count += +item.amount;
                }
                else {
                    isHasEdit = true;
                }
            });
            if (!isHasEdit) {
                this.listForm.otherList.forEach(function (item) {
                    if (item.isEdit) {
                        isHasEdit = true;
                    }
                });
            }
            alreadyCreateNewPlanAmount = count;
            this.$store.commit('repayment/update', {
                isDisabledAddBatch: count >= newPlanAmount || false,
                isHasEdit: isHasEdit,
                alreadyCreateNewPlanAmount: alreadyCreateNewPlanAmount,
            });
        },
        getSummaries: function (param) {
            var _this = this;
            var data = param.data;
            var arr = [];
            var status = true;
            var model = '';
            var modelChange = function (model) {
                var text = '';
                switch (model) {
                    case 'DAY_AVERAGE':
                        text = '日扣平均模式';
                        break;
                    case 'DAY_GREED':
                        text = '日扣优先模式';
                        break;
                    case 'ACTIVE':
                        text = '主动还款';
                        break;
                    default:
                        '';
                }
                return text;
            };
            arr[0] = '合计';
            arr[1] = data.length;
            arr[2] = [0];
            arr[4] = [];
            arr[5] = [];
            var amount = 0;
            data.forEach(function (item, index) {
                amount += +_this.$utils.toFen(item.amount);
                if (index === 0) {
                    var start = item.startTime ? item.startTime + ' 至 ' : '';
                    arr[4].push(start);
                }
                if (index === data.length - 1) {
                    arr[4].push(item.endTime);
                }
                if (model === '') {
                    model = item.mode;
                }
                else {
                    if (status && model !== item.mode) {
                        status = false;
                    }
                }
            });
            arr[2] = this.$utils.toYuan(amount);
            arr[3] = status ? modelChange(model) : '--';
            return arr;
        },
        getModeType: function (listType, index) {
            var mode = this.listForm[listType][index].mode;
            this.listForm[listType][index].modeType =
                mode === 'ACTIVE' ? 'now' : 'next';
            this.$refs['listForm'].validate(function (valid) {
                if (!valid) {
                    return false;
                }
            });
        },
        validatorNum: function () {
            return checkNum;
        },
        validatorDate: function (rule, value, callback) {
            var index = rule.index, listType = rule.listType;
            var modeType = this.listForm[listType][index].modeType;
            var startDate = new Date(value[0]).getTime();
            // const endDate = new Date(value[1]).getTime()
            var nowDate = new Date();
            var now = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()).getTime();
            var dayTime = 1 * 24 * 60 * 60 * 1000;
            // if (modeType === 'now') {
            //   if (startDate < now) {
            //     return callback(new Error('日期不能早于今天'))
            //   }
            //   return callback()
            // }
            if (modeType === 'next') {
                if (startDate < now + dayTime) {
                    return callback(new Error('日期必须大于今天'));
                }
                return callback();
            }
            callback();
        },
        changeYuan: function (val) {
            return this.$utils.toYuan(val);
        },
        changeMode: function (val) {
            return transSubType[val];
        },
        amountTypes: function (val) {
            var amountType = {
                MONTHLY_RENT: '租金/月供',
                PUNISHMENT: '违章罚款',
                DEPOSIT: '押金',
                MANAGEMENT: '管理费',
                INSURANCE: '保险',
            };
            return amountType[val];
        },
        spanMethods: function (_a) {
            var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: this.listForm.list.length,
                        colspan: 1,
                    };
                }
                else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
        importConfirm: function () {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"text\">\u60A8\u786E\u5B9A\u8981\u5BFC\u5165\u8FD8\u6B3E\u8BA1\u5212\u5230\u7CFB\u7EDF\u5417</p>",
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: '',
            })
                .then(function () {
                _this.importMain();
            })
                .catch(function () { });
        },
        importMain: function () {
            var _this = this;
            var data = {
                contractCode: this.contractCode,
                creator: this.usernameZh,
                plans: [],
            };
            var dataArr = JSON.parse(JSON.stringify(this.listForm.list.concat(this.listForm.otherList)));
            for (var i = 0; i < dataArr.length; i++) {
                if (i === 0) {
                    dataArr[i].duration_no = dataArr.length;
                }
                dataArr[i].amount = this.$utils.toFen(dataArr[i].amount);
                delete dataArr[i].eDate;
                delete dataArr[i].isEdit;
            }
            data.plans = dataArr;
            this.$request({
                method: 'post',
                url: '/proxy/api/plan/add',
                data: data,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (!res.errorCode) {
                    _this.$message({
                        message: '恭喜你成功导入创建的还款计划',
                        type: 'success',
                    });
                    _this.$store.commit('repayment/update', {
                        tabActiveName: 'batch',
                        isDefaultStatus: false,
                    });
                }
            });
        },
    },
    watch: {
        'listForm.list': {
            handler: function () {
                this.isAddBatch();
            },
            deep: true,
        },
        completeList: function () {
            this.initData();
            this.isAddBatch();
        },
        isDisabledImport: function (val) {
            this.$store.commit('repayment/update', {
                isDisabledImport: val,
            });
        },
    },
});
